export const accountQueryKeys = {
  all: ['contracting', 'account'] as const,
  bySalesforceId: (salesforceAccountId: string) =>
    [...accountQueryKeys.all, 'by-salesforce-id', salesforceAccountId] as const,
  details: (accountId: string) => [...accountQueryKeys.all, accountId, 'details'] as const,
};
